import React, { useState } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DeleteSweepOutlinedIcon from '@material-ui/icons/DeleteSweepOutlined';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import FormControl from '@material-ui/core/FormControl';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Button, TextField } from '@material-ui/core'

import { actions as companiesActions } from '../actions';
import { NAME as COMPANIES_NAME } from '../reducer';

const CONFIRMATION_WORD = 'ОЧИСТИТЬ'

// Красный, как у необратимых действий: пункт не спутать с соседними.
const useStyles = makeStyles((theme) => ({
  danger: { color: theme.palette.error.main },
}));

// Пункт бокового меню (в блоке входа, над «Выйти») и окно подтверждения обнуления.
function ResetSeasonData(props) {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [confirmation, setConfirmation] = useState('')

  const { isResetting } = props

  const closeDialog = () => {
    if (isResetting) return
    setOpen(false)
    setConfirmation('')
  }

  const confirmed = confirmation.trim().toUpperCase() === CONFIRMATION_WORD
  // Слово начали вводить, но оно не совпадает: объясняем, почему кнопка неактивна.
  const mistyped = confirmation.trim() !== '' && !confirmed

  return (
    <>
      <ListItem button className={classes.danger} onClick={() => setOpen(true)}>
        <ListItemIcon className={classes.danger}>
          <DeleteSweepOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary="Обнулить площадь, сбор и остатки" />
      </ListItem>
      <Dialog open={open} onClose={closeDialog} fullWidth maxWidth="sm">
        <DialogTitle>Обнуление площади, сбора и остатков</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Будут обнулены значения по всем компаниям и культурам: площадь
            посева, валовый сбор и остаток. Прежние цифры не сохраняются.
          </DialogContentText>
          <DialogContentText>
            Компании, контакты, список культур, заметки и мониторинг складов не
            затрагиваются.
          </DialogContentText>
          <DialogContentText>
            Действие необратимо. Для подтверждения введите слово {CONFIRMATION_WORD}.
          </DialogContentText>
          <FormControl fullWidth>
            <TextField
              label="Подтверждение"
              variant="outlined"
              value={confirmation}
              disabled={isResetting}
              error={mistyped}
              helperText={mistyped ? `Введите слово ${CONFIRMATION_WORD} без ошибок` : ' '}
              onChange={(e) => setConfirmation(e.target.value)}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={closeDialog} disabled={isResetting}>
            Отмена
          </Button>
          <Button
            variant="contained"
            color="secondary"
            disabled={!confirmed || isResetting}
            startIcon={isResetting ? <CircularProgress size={16} color="inherit" /> : null}
            onClick={() => {
              // Окно закрывается, когда сервер ответил; при ошибке остаётся открытым.
              Promise.resolve(props.resetProductValues()).then((action) => {
                if (action && action.type && !action.error && !action.type.endsWith('_FAILURE')) {
                  setOpen(false)
                  setConfirmation('')
                }
              })
            }}
          >
            {isResetting ? 'Очистка…' : 'Очистить'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

const mapStateToProps = (state) => ({
  isResetting: Boolean(state[COMPANIES_NAME] && state[COMPANIES_NAME].isResetting),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ resetProductValues: companiesActions.resetProductValues }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ResetSeasonData)
